import React, { memo, useMemo } from "react";
import { BillingCycleType } from "../types";
import SubscriptionCard from "./SubscriptionCard";
import { MemberProduct, Member } from "@/src/features/api/memberApi";
import type { MemberPlanInfo } from "@/src/hooks";
import { CountDownTime } from "@/src/hooks/usePlusCountDown";

interface SubscriptionCardListProps {
  plans: MemberProduct[];
  billingCycle: BillingCycleType;
  isLoading: boolean;
  userPlanInfo: Member & MemberPlanInfo;
  isTrial: boolean;
  onStripeClick?: (planId: string) => void;
  trialList?: MemberProduct[];
  hasActiveDiscount?: boolean;
  isDiscount?: boolean;
  time?: CountDownTime;
}

/**
 * 权益卡片列表组件 - 显示多个订阅计划卡片
 */
const CardList: React.FC<SubscriptionCardListProps> = ({
  plans,
  billingCycle,
  isLoading,
  userPlanInfo,
  isTrial,
  onStripeClick,
  trialList,
  hasActiveDiscount,
  isDiscount,
  time,
}) => {
  // 渲染订阅卡片
  const renderSubscriptionCards = useMemo(() => {
    return plans?.map((plan) => (
      <SubscriptionCard
        key={plan?.id}
        plan={plan}
        billingCycle={billingCycle}
        isLoading={isLoading}
        userPlanInfo={userPlanInfo}
        isTrial={isTrial}
        onStripeClick={onStripeClick}
        trialList={trialList}
        hasActiveDiscount={hasActiveDiscount}
        isDiscount={isDiscount}
        time={time}
      />
    ));
  }, [
    plans,
    billingCycle,
    isLoading,
    userPlanInfo,
    isTrial,
    trialList,
    hasActiveDiscount,
    isDiscount,
    time,
    onStripeClick,
  ]);

  return (
    <div className="flex flex-1 flex-wrap flex-row xl:gap-6 md:gap-4 max-md:gap-1 items-end justify-center mx-auto">
      {renderSubscriptionCards}
    </div>
  );
};

export default memo(CardList);
